export const listCompaniesWithEmployees = /* GraphQL */ `
  query ListCompaniesWithEmployees(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        inactiveAt
        country
        clients {
          items {
            id
            firstName
            lastName
            email
            inactiveAt
            employees {
              items {
                id
                clientID
                employeeID
                employee {
                  id
                  firstName
                  lastName
                  email
                  country
                  region
                  vacationAllowance
                }
              }
              nextToken
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listEmployeesWithCompanies = /* GraphQL */ `
  query ListEmployeesWithCompanies(
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        inactiveAt
        country
        region
        vacationAllowance
        clients {
          items {
            id
            clientID
            employeeID
            client {
              id
              firstName
              lastName
              companyClientsId
              company {
                id
                name
                createdAt
                updatedAt
                country
              }
              email
              createdAt
              updatedAt
            }
            employee {
              id
              firstName
              lastName
              email
              country
              region
              vacationAllowance
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listEmployeesWithTimelogs = /* GraphQL */ `
  query ListEmployeesWithTimelogs(
    $employeeID: ID = ""
    $limit: Int
    $nextToken: String
    $dateRange: [String] = null
    $logFilter: ModelTimelogFilterInput
    $nextTokenLogs: String
  ) {
    listEmployees(filter: {id: {contains: $employeeID}}, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        clients {
          items {
            id
            clientID
            employeeID
            client {
              id
              firstName
              lastName
              companyClientsId
              company {
                id
                name
                createdAt
                updatedAt
                country
              }
              email
              createdAt
              updatedAt
            }
            employee {
              id
              firstName
              lastName
              email
              country
              region
              vacationAllowance
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        timelogs(date: {between: $dateRange}, filter: $logFilter, nextToken: $nextTokenLogs) {
          items {
            id
            approved
            onCall
            date
            standard
            overtime
            sick
            holiday
            notes
            clientID
            employeeID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEmployeeWithCompany = /* GraphQL */ `
  query GetEmployeeWithCompany(
    $id: ID!
    $dateRange: [String] = null
    $filter: ModelTimelogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getEmployee(id: $id) {
      id
      firstName
      lastName
      email
      country
      region
      vacationAllowance
      clients {
        items {
          id
          clientID
          client {
              id
              firstName
              lastName
              companyClientsId
              company {
                id
                name
                createdAt
                updatedAt
                country
              }
              email
              createdAt
              updatedAt
            }
          employeeID
          employee {
              id
              firstName
              lastName
              email
              country
              region
              vacationAllowance
              createdAt
              updatedAt
            }
          createdAt
          updatedAt
        }
        nextToken
      }
      timelogs(date: {between: $dateRange}, filter: $filter, limit: $limit, nextToken: $nextToken) {
        items {
          id
          approved
          onCall
          date
          standard
          overtime
          sick
          holiday
          notes
          employeeID
          clientID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listClientsWithTimelogs = /* GraphQL */ `
query ListClientsWithTimelogs(
  $filter: ModelClientFilterInput
  $employeeID: ID = ""
  $dateRange: [String] = null
) {
  listClients(filter: $filter) {
    items {
      id
      firstName
      lastName
      company {
        name
      }
      timelogs(filter: {and: {approved: {eq: true}, employeeID: {contains: $employeeID}}}, date: {between: $dateRange}) {
        items {
          id
          approved
          onCall
          date
          standard
          overtime
          sick
          holiday
          notes
          employeeID
          clientID
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
}
`;

export const getEmployeeWithAbsences = /* GraphQL */ `
query GetEmployeeWithAbsences(
  $id: ID!
  $startDate: [String]!
) {
  getEmployee(id: $id) {
    id
    firstName
    lastName
    email
    country
    region
    vacationAllowance
    inactiveAt
    absences(startDate: {between: $startDate}) {
      items {
        id
        startDate
        endDate
        hoursTaken
        amount
        type
        description
        approvalStatus
        employeeID
        createdAt
        updatedAt
        approvedByClient
        notes
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;

export const listAbsencesWithEmployees = /* GraphQL */ `
query ListAbsencesWithEmployees(
  $filter: ModelAbsenceFilterInput
  $limit: Int
  $nextToken: String
) {
  listAbsences(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      description
      createdAt
      approvalStatus
      amount
      type
      endDate
      employeeID
      startDate
      hoursTaken
      updatedAt
      employee {
        country
        createdAt
        email
        firstName
        id
        inactiveAt
        lastName
        region
        updatedAt
        vacationAllowance
      }
    }
  }
}
`;

export const getEmployeeWithTimeInLieus = /* GraphQL */ `
query GetEmployeeWithTimeInLieus(
  $id: ID!
  $dateTaken: [String]!
) {
  getEmployee(id: $id) {
    id
    firstName
    lastName
    email
    country
    region
    vacationAllowance
    inactiveAt
    timeInLieus(dateTaken: {between: $dateTaken}) {
      items {
        id
        dateEarned
        dateTaken
        hoursTaken
        description
        notes
        approvalStatus
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;

export const listTimeInLieusWithEmployees = /* GraphQL */ `
query ListTimeInLieusWithEmployees(
  $filter: ModelTimeInLieuFilterInput
  $limit: Int
  $nextToken: String
) {
  listTimeInLieus(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      dateEarned
      dateTaken
      hoursTaken
      description
      notes
      approvalStatus
      employeeID
      employee {
        country
        createdAt
        email
        firstName
        id
        inactiveAt
        lastName
        region
        updatedAt
        vacationAllowance
      }
    }
  }
}
`;